import { defineComponent as _defineComponent } from 'vue';
import { BAlert, BButton } from "bootstrap-vue";
import { ref } from "vue";
import ConfigurationTestSummaryModal from "@/components/ConfigTemplates/ConfigurationTestSummaryModal.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActionSummary',
    props: {
        error: null,
        testResults: null,
        errorDataDescription: null
    },
    setup(__props) {
        const showTestResults = ref(false);
        return { __sfc: true, showTestResults, BAlert, BButton, ConfigurationTestSummaryModal };
    }
});
